module.exports = __webpack_public_path__ + "media/assets/images/leanbit_home/nosco_interfaccia_home-acc70262e834de59a43eafd2c04adcdd.png";